import React from 'react';
import MapComponent from '../components/MapComponent';
import { type Site } from '../data/sites';
import './MapPage.css';

const MapPage: React.FC = () => {
  const handleSiteClick = (site: Site) => {
    console.log('Sitio seleccionado:', site);
  };

  return (
    <div className="map-page">
      <div className="map-content">
        <MapComponent onSiteClick={handleSiteClick} />
      </div>
    </div>
  );
};

export default MapPage;
